import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { getSessionStorageItem, SESSION_STORAGE_ANALYSIS_KEY } from "../../../../sessionStorage";
import AnalysisData from "../../../Helpers/Constants/AnalysisData";
import TermLengthAnalysis from "./TermLengthAnalysis";

export default function TermLengthCalculator(props) {

  const sessionStorageFromAnalysis = getSessionStorageItem(SESSION_STORAGE_ANALYSIS_KEY);
  const [analysisFormValues, setAnalysisFormValues] = useState(sessionStorageFromAnalysis || AnalysisData());
  
  const handleModalOnClose = () => {
    sessionStorage.setItem(SESSION_STORAGE_ANALYSIS_KEY, JSON.stringify({ ...analysisFormValues }));
    props.fields.setModalTermLengthCalculatorIsOpen(false);
  };

  return (
    <Modal
      show={props.fields.modalTermLengthCalculatorIsOpen}
      className="term-analysis-model"
      scrollable={true}
      onHide={() => handleModalOnClose()}
      backdrop="true"
      size="lg"
    >
      <Modal.Body>
        <TermLengthAnalysis
          fields={props.fields}
          isPrequote={props.isPrequote}
          isCustomTerm={props.isCustomTerm}
          onTermLengthCalculation={props.onTermLengthCalculation}
          setAnalysisFormValues={setAnalysisFormValues}
        />
      </Modal.Body>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/TermLengthCalculator/TermLengthCalculator.js